import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import {compose} from "redux";
import {connect} from "react-redux";
import {
    filterRequestsTable,
    setRequests,
    editRequests,
    editPayment,
    editClosedRequests, editClosedPayment, setClosedRequests, filterClosedRequestsTable,
} from "../../redux/actions/Tabs-Actions";
import SvGraphics from "../../assets/SvGraphics";
import doctorApi from "../../services/ApiServices/doctorApi";
import TreatmentTable from "../../components/TableComponents/TreatmentTable";
import {authenticationService} from "../../services/AuthenticationService";
import {history} from "../../utils/history";
import PatientEditComment from "../../components/doctor/PatientEditComment";
import PatientEditPayment from "../../components/doctor/PatientEditPayment";
import PaginationTable from "../../components/TableComponents/PaginationTable";
import NewPaginationTable from "../../components/TableComponents/NewPaginationTable";
import _ from 'lodash';
import {appendIchilovQuery, hasIchilovQuery} from "../../utils/routeUtils";


class LeumitPatientRequestsComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: 0,
            requests: [],
            statuses: [],
            originRequests:[],
            isSideBarOpen: false,
            isPaymentSideBarOpen: false,
            isPageLoading: false,
            entry: null,
            count:0,
            filters: {}
        }
        this.onSearchFilter = _.debounce(this.onSearchFilter.bind(this),500);
    }


    getInsurace(insuranceID){
        let language = localStorage.getItem('language')
        switch (insuranceID.toString()) {
            case "1": return language==="he" ? "מכבי" : "Maccabi"
            case "2": return  language==="he" ? "כללית":"Clalit"
            case "3": return  language==="he" ? "לאומית":"Leumit"
            case "4": return  language==="he" ? "מאוחדת":"Meuhedet"
            case "5": return  language==="he" ? "חברת ביטוח":"Insurance company"
            case "6": return  language==="he" ? "צה\"ל":"IDF"
            case "7": return  language==="he" ? "משרד הביטחון":"Ministry of Defence"
            case "8": return  language==="he" ? "ללא ביטוח":"No Insurance"
            case "9": return  language==="he" ? "רשות פלסטינאית":"The Palestinian Authority"
            case "10": return language==="he" ? "אחר":"Other"
            default:return ""
        }
    }

     getRequest= async (viewNum,pageNum,filters)=> {
        let {requests,statuses} = this.state


        let currentPage=pageNum ? pageNum : 0

        let language = localStorage.getItem('language')
        let additionalReq=[]

         if(!filters){
             let viewKey= this.state.view===0?"requestsFilter":"doneRequestsFilter"
             filters= localStorage.getItem(viewKey)?JSON.parse(localStorage.getItem(viewKey)):{}
         }

        if (viewNum === 0) {
            additionalReq = await doctorApi.getLeumitRequests(currentPage,filters)
        } else {
            additionalReq = await doctorApi.getLeumitDoneRequests(currentPage,filters)
        }

        let count =additionalReq ?additionalReq.data.count :0
        additionalReq = additionalReq ? additionalReq.data.rows : []
        localStorage.setItem("view",viewNum)

        additionalReq.forEach(item=>{
            let patientPII= item && item.Patient && item.Patient.PII?item.Patient.PII:{}

            let insurance= this.getInsurace(patientPII.Insuring_factor)
            let statusTofind=item.requestStatus?item.requestStatus:""
            let statusIndex = statuses.findIndex((element)=> element.status_ID.toString()===statusTofind.toString());

            let status=""
            if(statusIndex>=0){
                status= language==="he" ?statuses[statusIndex]?.status_desc_he:statuses[statusIndex]?.status_desc

            }
            let programm = item.choose_programm
            if(language==="he"){
                programm = programm === "new" ? "הוצאת רישיון חדש" : programm
                programm = programm === "renew" ? "חידוש רישיון למטופלים קיימים" : programm
                programm = programm === "renew2" ? "חידוש רישיון למטופלים חדשים" : programm
                programm = programm === "newPrescription" ? "הוצאת מרשם חדש"  : programm
                programm = programm === "renewPrescription" ? "חידוש מרשם למטופלים קיימים" : programm
                programm = programm === "renew2Prescription" ? "חידוש מרשם למטופלים חדשים" : programm
            }
            let date= item.PatientsPayment ?new Date(item.PatientsPayment.paymentDate): ''

            item['PatientName']=patientPII.First_name + " " +patientPII.Last_name
            item['ShowFlag']=item && item.Patient && item.Patient.ShowFlag
            item['PatientID']=patientPII.ID_passport
            item['insurance']=insurance
            item['choose_programm']=programm
            item['requestStatus']=status
            item['resourceName']=patientPII?.RequestSource?.RequestSource_Name
            item['HasInfo']=item.RequestInfo && item.RequestInfo.length>0?"Y":"N"
            item['paymentDate']=date
            item['PayedSum']=item.PatientsPayment ?item.PatientsPayment.Sum:0
            item['isPaid']=item.PatientsPayment ?"Y":"N"
            item['renewCurrentDose']=item.renewCurrentDose==="Yes"?"Y":"N"
        })



        requests=additionalReq
        this.setState({requests:requests,count:count})
    }
    async componentDidMount() {
        let viewSaved= localStorage.getItem("view")

        if(!viewSaved){
            viewSaved=0
            localStorage.setItem("view",0)
        }else {
            viewSaved = parseInt(viewSaved)
        }

        let statuses = await doctorApi.getAllStatuses()
        if (statuses) {
            this.setState({statuses: statuses.data})
        }
        await this.changeView( parseInt(viewSaved),0)
    }



    getStatus(id) {
        let {statuses} = this.state
        let language = localStorage.getItem('language')
        for(let i =0;i<statuses.length;i++){
            if(id===statuses[i].status_ID){
                if(language==="he"){
                    return statuses[i].status_desc_he
                }else{
                    return statuses[i].status_desc
                }
            }
        }
    }
    async changeView(viewNum) {
        this.setState({isPageLoading:true})
        localStorage.setItem("view",viewNum)
        this.setState({view: viewNum})
        let localSaveFilterRequests={}
        if (viewNum === 0) {
             localSaveFilterRequests= localStorage.getItem("requestsFilter")?JSON.parse(localStorage.getItem("requestsFilter")):{}
            delete localSaveFilterRequests['orderBy']

        } else {
            localSaveFilterRequests= localStorage.getItem("doneRequestsFilter")?JSON.parse(localStorage.getItem("doneRequestsFilter")):{}
            delete localSaveFilterRequests['orderBy']
        }
        await this.getRequest(viewNum,0,localSaveFilterRequests)
        this.setState({isPageLoading:false,filters:localSaveFilterRequests})

    }

    onRowClick = (rowInfo) => {
        history.push({
            pathname: appendIchilovQuery(`/pain_patientRequest`),
            state: {
                rowInfo,
                completed: false,
                from: {
                    fromPath: `/pain_requests_dashboard`,
                }
            },
        })
    }


    getColumns = (t) => {
        let {statuses}=this.state
        let language = localStorage.getItem('language')
        // let statusOptions =[]
        // for(let i=0;i<statuses.length;i++){
        //     language==="he"?statusOptions.push(<option value={statuses[i].status_ID}>{statuses[i].status_desc_he}</option>)
        //         :statusOptions.push(<option value={statuses[i].status_ID}>{statuses[i].status_desc}</option>)
        // }

        return [
            {accessor: 'RequestID', Header: t('hcpLeumitPatientRequests.requestNum'), width:120,resizable: false,Cell: ({original}) => {
                    return(
                        <div onClick={e => {
                            e.stopPropagation();
                            this.onRowClick(original)
                        }} style={{width: 'fit-content',fontSize:'18px',cursor: 'pointer'}}>{original.RequestID}</div>
                    );

                }},


            {accessor: 'PatientName', Header: t('hcpLeumitPatientRequests.patientName'), width:240,resizable: false,Cell: ({original}) => {
                    return (
                        <div onClick={e => {
                            e.stopPropagation();
                            this.onRowClick(original)
                        }} style={{/*fontWeight:'550',*/cursor: 'pointer', width: 'fit-content',fontSize:'18px'}}>{original.PatientName}</div>
                    );
                }},
            {accessor: 'PatientID', Header: t('hcpLeumitPatientRequests.id'), resizable: false,width:150,className:'dashboardText',Cell: ({original}) => {
                return(
                  <div style={{width: 'fit-content',fontSize:'18px'}}>{original.PatientID}</div>
                );
                }},

            {accessor: 'IsLicense', Header: t('hcpLeumitPatientRequests.License'), makeFilter: true,resizable: false,width:100,className:'dashboardText',Cell: ({original}) => {
                    return (
                             original.IsLicense &&
                             <SvGraphics svgname={'check-icon'} style={{width: '20px', height: '20px'}}/>

                    );
                }},
  /*          {accessor: 'Doctor_Indication', Header: t('hcpLeumitPatientRequests.doctorIndication'), makeFilter: false,resizable: false,width:180,className:'dashboardText',Cell: ({original}) => {
                    let indication =original.Doctor_Indication
                    indication=indication==="Indication1"?t('hcpLeumitPatientRequests.Indication1'):indication
                    indication=indication==="Indication2"?t('hcpLeumitPatientRequests.Indication2'):indication
                    indication=indication==="Indication3"?t('hcpLeumitPatientRequests.Indication3'):indication
                    indication=indication==="Indication4"?t('hcpLeumitPatientRequests.Indication4'):indication
                    indication=indication==="Indication5"?t('hcpLeumitPatientRequests.Indication5'):indication
                    indication=indication==="Indication6"?t('hcpLeumitPatientRequests.Indication6'):indication
                    indication=indication==="Indication7"?t('hcpLeumitPatientRequests.Indication7'):indication
                    indication=indication==="Indication8"?t('hcpLeumitPatientRequests.Indication8'):indication
                    indication=indication==="Indication9"?t('hcpLeumitPatientRequests.Indication9'):indication
                    indication=indication==="Indication10"?t('hcpLeumitPatientRequests.Indication10'):indication
                    indication=indication==="Indication11"?t('hcpLeumitPatientRequests.Indication11'):indication
                    indication=indication==="Indication12"?t('hcpLeumitPatientRequests.Indication12'):indication
                    indication=indication==="Indication13"?t('hcpLeumitPatientRequests.Indication13'):indication
                    indication=indication==="Indication14"?t('hcpLeumitPatientRequests.Indication14'):indication
                    return (
                        /!*     original.IsLicense &&
                             <SvGraphics svgname={'check-icon'} style={{width: '20px', height: '20px'}}/>*!/
                        <div style={{width: 'fit-content', fontSize: '18px'}}>
                            <label>{indication}</label>
                        </div>
                    );
                }},*/

            {accessor: 'choose_programm', Header: t('hcpLeumitPatientRequests.requestType'),makeFilter: true, resizable: false,
                width:240,Cell: ({original}) => {
                let programm =original.choose_programm
                    programm=programm==="new"?t('patient_self_boarding.new_license'):programm
                    programm=programm==="renew"?t('patient_self_boarding.renew_license'):programm
                    programm=programm==="renew2"? t('patient_self_boarding.renew2_license'):programm
                    programm=programm==="change"? t('patient_self_boarding.change_dose'):programm
                    programm = programm === "newPrescription" ? t('patient_self_boarding.new_Prescription') : programm
                    programm = programm === "renewPrescription" ? t('patient_self_boarding.renew_Prescription') : programm
                    programm = programm === "renew2Prescription" ? t('patient_self_boarding.renew2_Prescription') : programm
                    return(
                        <div style={{width: 'fit-content',fontSize:'18px'}}>{programm}</div>
                    );
                }},
            {accessor: 'renewCurrentDose', Header: t('hcpLeumitPatientRequests.isRenewCurrentDose'),makeFilter: false,width:100,resizable: false,Cell: ({ original }) => {
                    return (
                        original.renewCurrentDose==="Y"&&
                        <SvGraphics svgname={'check-icon'} style={{width:'20px',height:'20px'}}/>
                    )
                }}
            ,
            {accessor: 'requestDate', Header: t('hcpLeumitPatientRequests.requestDate'), resizable: false,width:180,Cell: ({ original }) => {
                    let date = original.requestDate?original.requestDate.split('T'):''
                    let currentDate = date[0].split('-').reverse().join('/')
                    return (
                        <div style={{width: 'fit-content',fontSize:'18px'}}>
                        <label>{currentDate}</label>
                        </div>
                    )
                }
            },
            {accessor: 'requestStatus', Header: t('hcpLeumitPatientRequests.status'),makeFilter: true,width:160,resizable: false,Cell: ({ original }) => {
                return (
                    <div style={{width: 'fit-content',fontSize:'18px'}}>
                    {/*<label>{this.getStatusDesc(original.requestStatus)}</label>*/}
                    <label>{original.requestStatus}</label>
                    </div>
                    )
                }},
            {accessor: 'resourceName', Header: "בית חולים",makeFilter: true,width:120,resizable: false,Cell: ({ original }) => {
                return (
                    <div style={{width: 'fit-content',fontSize:'18px'}}>
                        <label>{original.Patient?.PII?.RequestSource?.RequestSource_Name}</label>
                    </div>
                    )
                }},
            {accessor: 'insurance', Header: t('hcpLeumitPatientRequests.insurance'),makeFilter: true,width:120,resizable: false,Cell: ({ original }) => {
                return (
                    <div style={{width: 'fit-content',fontSize:'18px'}}>
                        <label>{original.insurance}</label>
                    </div>
                    )
                }},
            {accessor: 'paid', Header: t('hcpLeumitPatientRequests.isPaid'),makeFilter: false,width:80,resizable: false,Cell: ({ original }) => {
                    return (
                        original.isPaid==="Y"&& original.PayedSum>0?
                        <SvGraphics svgname={'check-icon'} style={{width:'20px',height:'20px'}}/>:
                            <SvGraphics svgname={'minus-icon'} style={{width:'20px',height:'20px'}}/>
                    )
                }}
        ,
  /*          {accessor: 'hasOldRequest', Header: t('hcpLeumitPatientRequests.hasOldRequest'),makeFilter: false,width:150,resizable: false,Cell: ({ original }) => {
                    return (
                        original.hasOldRequest==="T" &&
                        <SvGraphics svgname={'check-icon'} style={{width:'20px',height:'20px'}}/>
                    )
                }}
        ,*/

            {accessor: 'hasComment', Header: t('hcpLeumitPatientRequests.hasComment'),makeFilter: false,width:70,resizable: false,Cell: ({ original }) => {
                    return (
                        original.HasInfo==="Y"&&
                        <SvGraphics svgname={'check-icon'} style={{width:'20px',height:'20px'}}/>
                    )
                }}
        ]
    }

    onOderByFunction = (event) =>{
        this.onFilterDataSelected({orderBy:event})
    }

    onSearchFilter = (filter) =>{
        this.onFilterDataSelected(filter)
    }

    onFilterDataSelected = async (filter) => {
        let {filters,view} =this.state
        if(filter['requestStatus']){
            filters['requestStatus'] = filter['requestStatus']
        }else if(filter['insurance']){
            filters['insurance'] = filter['insurance']
        }else if(filter['IsLicense']){
            filters['IsLicense'] = filter['IsLicense']
        }else if(filter['choose_programm']){
            filters['choose_programm'] = filter['choose_programm']
        }else if(filter['Search'] || filter['Search']===''){
            filters['Search'] = filter['Search']
        }else if(filter['resourceName'] || filter['resourceName']===''){
            filters['resourceName'] = filter['resourceName']
        }else if(filter['orderBy']) {
            if(filters['orderBy'] && filters['orderBy'].key ===filter['orderBy']){
                filters['orderBy'].action=filters['orderBy'].action ==="ASC"?"DESC":"ASC"
            }else{
                filters['orderBy']={key:filter['orderBy'],action:'ASC'}
            }

        }

        if(view === 0){
            localStorage.setItem("requestsFilter",JSON.stringify(filters) )
        }else{
            localStorage.setItem("doneRequestsFilter",JSON.stringify(filters))
        }
        await this.getRequest(this.state.view, 0,filters)
        this.setState({filters})

    }


    setRequestMoreFunctions = () => {
        let {t} = this.props
        const hasIchilov = hasIchilovQuery()
        return [
            {
                name: "Edit Comment",
                display: t('hcpLeumitPatientRequests.editComment'),
                call: (patient => this.openSideBar(patient))
            },{
                name: "Edit Payment",
                display: t('hcpLeumitPatientRequests.editPayment'),
                call: (patient => this.openPaymentSideBar(patient))
            },{
                name: "Edit Source",
                display: hasIchilov?"שייך ללאומית":"שייך לאיכילוב",
                call: (async patient => await this.editSource(patient))
            }
        ]
    }

    async editSource(patient) {
        let {view} = this.state
        await doctorApi.changeResource(patient.UserStorageID)
        await this.changeView( view)

    }

    async openSideBar(patient) {
        await this.setState({entry: patient, isSideBarOpen: true})
        document.body.style.overflow = "hidden"
    }
    async openPaymentSideBar(patient) {
        await this.setState({entry: patient, isPaymentSideBarOpen: true})
        document.body.style.overflow = "hidden"
    }

    editRequests(patient){
        let {requests}=this.state
        let findIndex = requests.findIndex(item=>item.RequestID === patient.RequestID)
        if(findIndex>=0){
            requests[findIndex]=patient
            requests[findIndex]['HasInfo']=patient.RequestInfo && patient.RequestInfo.length>0?"Y":"N"
        }
        this.setState({requests})
    }

    editPayment(patient){
        let {requests}=this.state
        let findIndex = requests.findIndex(item=>item.RequestID === patient.RequestID)
        if(findIndex>=0){
            requests[findIndex]=patient
            requests[findIndex]['isPaid']=patient.paymentDate ?"Y":"N"
        }
        this.setState({requests})
    }
    render() {
        let {view,count,requests,filters} = this.state
        let{requestsData} = this.props
        let {t} = this.props
        let {entry,isSideBarOpen,isPaymentSideBarOpen} = this.state



        if(this.state.isPageLoading){
            return (<div className="loader"/>)
        }


        return (

            <div>

                <div className={'asaya-info-Leumit'}>
                    <div className={'asaya-info-label-Leumit'}>
                        {t('hcpLeumitPatientRequests.request')}
                    </div>
                </div>


                <div className={'requests-Tabs'}>


                    <div style={{width: '79%', display: 'flex'}}>
                        <div className={view === 0 ? 'requests-Tab-selected' : 'requests-Tab'}
                             onClick={() => this.changeView(0)}>{t('hcpLeumitPatientRequests.to_handle')}</div>
                        <div className={view === 1 ? 'requests-Tab-selected' : 'requests-Tab'}
                             onClick={() => this.changeView(1)}>{t('hcpLeumitPatientRequests.closed')}</div>
                    </div>
                    <div className={'sade-left-navbar-search-input-patient'}>
                        {view === 0 && <input className={"navbar-search-input-patient"} placeholder={t('doctor.search_name_or_id')}
                                type="text" name="search" defaultValue={filters.Search?filters.Search:""}
                                onChange={event => this.onSearchFilter({Search:event.target.value})} id={"search"}
                        />}
                        {view === 1 && <input className={"navbar-search-input-patient"} placeholder={t('doctor.search_name_or_id')}
                                type="text" name="search" defaultValue={filters.Search?filters.Search:""}
                                onChange={event => this.onSearchFilter({Search:event.target.value})} id={"search"}
                        />}
                        <SvGraphics className={"input-pic-patient"} svgname={'search'}/>
                    </div>

                </div>
                <div className={'sade-requests-count-label'}>{count} {t('hcpLeumitPatientRequests.request')}</div>


                 <div className={'context-area'}>
                    <NewPaginationTable
                        data={requests}
                        initialData={requests}
                        columns={this.getColumns(t)}
                        hasMore={true}
                        TabView={this.state.view}
                        statuses={this.state.statuses}
                        rowsCount ={count}
                        defaultPageSize={14}
                        hasSelection={false}
                        moreFunctions={this.setRequestMoreFunctions()}
                        hasShowInfo={false}
                        onFilterDataSelected={filter => this.onFilterDataSelected(filter)}
                        onOderByFunction={event => this.onOderByFunction(event)}
                        getRequest={ (TabView, pageNum) => this.getRequest(TabView, pageNum)}
                    />
                </div>

                {isSideBarOpen && <PatientEditComment
                    t={e => t(e)}
                    title={t('hcpLeumitPatientRequests.Comment')}
                    entry={entry}
                    editRequest={patient => this.editRequests(patient)}
                    isSideBarOpen={isSideBarOpen}
                    closeSideBar={() => this.setState({isSideBarOpen: false})}/>}

                {isPaymentSideBarOpen && <PatientEditPayment
                    t={e => t(e)}
                    title={t('hcpLeumitPatientRequests.editPayment')}
                    entry={entry}
                    editPayment={patient => this.editPayment(patient)}
                    isPaymentSideBarOpen={isPaymentSideBarOpen}
                    closeSideBar={() => this.setState({isPaymentSideBarOpen: false})}/>}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
/*        editRequests: request => dispatch(editRequests(request)),
        editPayment: request => dispatch(editPayment(request)),
        setRequests:(patients,statuses) => dispatch(setRequests(patients,statuses)),
        filterRequestsTable: (searchType, payload) => dispatch(filterRequestsTable(searchType, payload)),
        editClosedRequests: request => dispatch(editClosedRequests(request)),
        editClosedPayment: request => dispatch(editClosedPayment(request)),
        setClosedRequests:(patients,statuses) => dispatch(setClosedRequests(patients,statuses)),
        filterClosedRequestsTable: (searchType, payload) => dispatch(filterClosedRequestsTable(searchType, payload))*/
    };
}

const mapStateToProps = state => {
    return {
/*        requestsData: state.patientRequestsTableDataReducer.requestsData,
        initiateRequestsData: state.patientRequestsTableDataReducer.initiateRequestsData,
        closedRequestsData: state.patientClosedRequestsTableDataReducer.closedRequestsData,
        initiateClosedRequestsData: state.patientClosedRequestsTableDataReducer.initiateClosedRequestsData*/
    };
};

const LeumitPatientRequests = compose(
    withTranslation(),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(LeumitPatientRequestsComposed);
export default LeumitPatientRequests;
